var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.$store.getters.homepageSliderImages.length > 0
        ? _c(
            "carousel",
            {
              staticClass: "homepageSlider cssClass",
              class: {
                isMobile: _vm.isMobile,
                isMd: !_vm.isMobile && !_vm.$store.getters.isKiosk,
                isKiosk: _vm.$store.getters.isKiosk,
              },
              attrs: {
                "per-page": 1,
                loop: "",
                navigationEnabled: true,
                navigationNextLabel: "",
                navigationPrevLabel: "",
                paginationEnabled: false,
                autoplay: true,
                autoplayTimeout: 6000,
                autoplayHoverPause: false,
              },
            },
            _vm._l(_vm.sliderImages, function (image, index) {
              return _c(
                "slide",
                {
                  key: index,
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.showImage(image.deepLink || "")
                    },
                  },
                },
                [
                  _vm.$store.getters.isKiosk && !_vm.densed
                    ? _c("v-img", {
                        class: { pointer: !!image.deepLink },
                        attrs: {
                          "aspect-ratio": "0.6",
                          src: image.URL,
                          cover: "",
                          "max-height": "1100",
                        },
                      })
                    : _vm.$store.getters.isKiosk && _vm.densed
                    ? _c("v-img", {
                        class: { pointer: !!image.deepLink },
                        attrs: {
                          "aspect-ratio": "1.777",
                          src: image.URL,
                          cover: "",
                          "max-height": "350",
                        },
                      })
                    : _c("v-img", {
                        class: { pointer: !!image.deepLink },
                        attrs: {
                          "aspect-ratio": "1.777",
                          src: image.URL,
                          cover: "",
                          "max-height": "800",
                        },
                      }),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }